import { createApp } from 'vue';
import store from "./store";
import components from './components';


const app = createApp({
  store,
  components,
  mounted() {
    import('../loadModules');
  },
});

app.use(store);
app.mount('#app');
